import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "submitBtn", "slide", "prevBtn", "nextBtn", "completeForm", "tooltip", "firstName", "lastName", "estateName"]
  static values = { mode: String }

  connect() {
    if (this.modeValue === "tutorial") {
      this.currentSlide = 0
      this.updateTutorialNav()
    }
  }

  // ——— Welcome page: choice selection ———

  selectChoice(event) {
    const label = event.currentTarget
    const radio = label.querySelector("input[type=radio]")
    if (!radio) return

    // Deselect all
    this.element.querySelectorAll(".onboarding-choice").forEach(el => el.classList.remove("selected"))
    // Select this one
    label.classList.add("selected")
    radio.checked = true

    // Enable submit
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = false
    }
  }

  // ——— Planning page: tooltip toggle ———

  showTooltip(event) {
    const btn = event.currentTarget
    const item = btn.closest(".onboarding-check-item")
    const bubble = item?.querySelector("[data-onboarding-target='tooltip']")
    if (!bubble) return

    const isVisible = bubble.style.display !== "none"
    // Hide all tooltips first
    this.tooltipTargets.forEach(t => { t.style.display = "none" })
    // Toggle this one
    if (!isVisible) bubble.style.display = "block"
  }

  // ——— Estate details: auto-fill estate name ———

  updateEstateName() {
    if (!this.hasEstateNameTarget) return
    const first = this.hasFirstNameTarget ? this.firstNameTarget.value.trim() : ""
    const last  = this.hasLastNameTarget  ? this.lastNameTarget.value.trim()  : ""
    const full  = [first, last].filter(Boolean).join(" ")
    if (full) {
      this.estateNameTarget.value = `${full}'s Estate`
    }
  }

  // ——— Tutorial slide navigation ———

  nextSlide() {
    const total = this.slideTargets.length
    if (this.currentSlide < total - 1) {
      this.goToSlideIndex(this.currentSlide + 1)
    }
  }

  prevSlide() {
    if (this.currentSlide > 0) {
      this.goToSlideIndex(this.currentSlide - 1)
    }
  }

  goToSlide(event) {
    const idx = parseInt(event.currentTarget.dataset.slide, 10)
    this.goToSlideIndex(idx)
  }

  goToSlideIndex(idx) {
    // Hide current
    this.slideTargets[this.currentSlide].style.display = "none"
    // Show new
    this.currentSlide = idx
    const newSlide = this.slideTargets[this.currentSlide]
    newSlide.style.display = "block"
    newSlide.style.animation = "none"
    // Trigger reflow for animation
    void newSlide.offsetWidth
    newSlide.style.animation = ""

    this.updateTutorialNav()
  }

  updateTutorialNav() {
    const total = this.slideTargets.length
    const isFirst = this.currentSlide === 0
    const isLast  = this.currentSlide === total - 1

    // Prev button visibility
    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.style.visibility = isFirst ? "hidden" : "visible"
    }

    // Next vs Get Started
    if (this.hasNextBtnTarget && this.hasCompleteFormTarget) {
      if (isLast) {
        this.nextBtnTarget.style.display = "none"
        this.completeFormTarget.style.display = "block"
      } else {
        this.nextBtnTarget.style.display = "inline-flex"
        this.completeFormTarget.style.display = "none"
      }
    }

    // Dots
    this.element.querySelectorAll(".tutorial-dot").forEach((dot, i) => {
      dot.classList.toggle("active", i === this.currentSlide)
    })
  }

  // Close tooltips when clicking outside
  clickOutside(event) {
    if (!event.target.closest(".onboarding-check-item")) {
      this.tooltipTargets.forEach(t => { t.style.display = "none" })
    }
  }
}
